import { grey } from "@mui/material/colors";

const styles = {
  active: { backgroundColor: grey[200] },
};

export default styles;
